import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ProgressBarModule } from 'primeng/progressbar';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [FileUploadComponent],
  imports: [CommonModule, FormsModule, ButtonModule, RippleModule, ProgressBarModule, InputTextModule],
  exports: [FileUploadComponent],
})
export class FileUploadModule {}
